(async () => {
    const { Core } = await importModule('Core');
    const { $toggleDisplay } = await importModule('Utils');

    customElements.define('buy-with-counter', class extends Core {
        elements = {
            addOne: '[data-element="add-one"]',
            addMany: '[data-element="add-many"]'
        }

        subscriptions = {
            'buyWith:change': '_updateCounter'
        }

        render() {
            this.subscribe('buyWith:change');
        }

        _updateCounter({ selected }) {
            const count = selected + 1;
            this.$addMany.querySelector('[data-i18n-amount]').textContent = count;
            $toggleDisplay(this.$addMany, count > 1)
            $toggleDisplay(this.$addOne, count <= 1)
        }

        setFeedback(originalHTML = null, onRestore = null) {
            const $active = this.$addMany.hidden ? this.$addOne : this.$addMany;
            
            // Use provided originalHTML if available, otherwise store current state
            const original = originalHTML !== null ? originalHTML : $active.innerHTML;

            $active.textContent = 'Added';

            setTimeout(() => {
                $active.innerHTML = original;
                
                // Call onRestore callback if provided (to re-enable button)
                if (typeof onRestore === 'function') {
                    onRestore();
                }
            }, 1000);
        }
    })
})();